/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
export function convertRemToPixel(remValue: number): number {
    return remValue * parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function convertPixelToRem(pxValue: number): number {
    return pxValue / parseFloat(getComputedStyle(document.documentElement).fontSize);
}
